import { createCacheState } from './cache'

export default {
  ...createCacheState(),
}
